// Hobbies / co-curricular skills a mentor can teach beyond academics — stored as
// advertising.hobbies (string labels), picked in ProfileSetup + AdminMentorEdit, shown
// on the mentor card/profile, and filterable in the directory. Free-form on the backend
// (no whitelist); this list only drives the picker options.
export const HOBBY_OPTIONS = [
  // Music. 'Music' is a deliberate umbrella entry: it is the Hobbies track's seeded
  // default, so it MUST exist here byte-identically (see TRACKS in lib/tracks.ts) —
  // a default that isn't in its own option list renders as an unselected chip.
  'Music',
  'Vocals / Singing', 'Vocals (Hindustani)', 'Vocals (Carnatic)', 'Vocals (Western)', 'Guitar', 'Piano / Keyboard',
  'Tabla', 'Drums', 'Violin', 'Flute', 'Harmonium', 'Sitar', 'Ukulele', 'Music Production / DJing',
  // Visual arts
  'Painting', 'Sketching / Drawing', 'Digital Art', 'Calligraphy', 'Pottery', 'Sculpture',
  'Photography', 'Rangoli', 'Mehndi / Henna',
  // Digital, media & design
  'Video Editing', 'Videography / Filmmaking', 'Photo Editing (Photoshop / Lightroom)',
  'Graphic Design', 'Animation', 'Motion Graphics', '3D Modelling', 'UI / UX Design', 'Web Design',
  'Content Creation (YouTube)', 'Reels / Short-form Video', 'Podcasting', 'Vlogging', 'Voice-over',
  'Coding for Kids',
  // Dance
  'Classical Dance', 'Bharatanatyam', 'Kathak', 'Kuchipudi', 'Odissi', 'Bollywood Dance', 'Hip-hop / Western Dance',
  'Western Dance', 'Hip-hop',
  'Contemporary Dance', 'Folk Dance', 'Salsa / Ballroom',
  // Performing & speaking
  // 'Public Speaking' deliberately excluded — it is a Career Skill (see CAREER_SKILL_OPTIONS
  // in lib/tracks.ts), not a hobby.
  'Theatre / Drama', 'Anchoring / Hosting', 'Stand-up Comedy', 'Storytelling', 'Debate', 'Magic',
  // Fitness & movement practices. Competitive games (cricket, football, badminton, chess,
  // swimming, athletics, martial arts…) deliberately live in SPORT_OPTIONS / sportsTaught
  // instead — a label must sit in exactly one field, or the same mentor splits across the
  // directory's Hobby and Game facets. Fitness stays here so a yoga or Zumba teacher isn't
  // forced to claim a "Sports Coaching" exam just to reach the games picker.
  'Yoga', 'Gym / Strength Training', 'Zumba', 'Aerobics', 'Pilates',
  // Instructor-led physical skills. Swimming and martial arts stay in SPORT_OPTIONS (they are
  // competitive games); these are taught one-to-one and have no league behind them.
  // Cycling deliberately NOT here — it is in SPORT_OPTIONS, and a label may live in exactly
  // one field or the same mentor appears under both the Hobby and Game facets.
  'Fitness Training', 'Skating', 'Horse Riding',
  // Both-list entries: teachable AND enjoyed personally (see PERSONAL_INTEREST_OPTIONS).
  'Scuba Diving', 'Driving',
  // Crafts & DIY
  'Knitting / Crochet', 'Embroidery', 'Origami', 'Jewellery Making', 'Candle / Soap Making', 'Gardening',
  // Lifestyle & other
  // Cooking as leisure. The professional side (Professional Cookery, Culinary Arts…) lives
  // in CAREER_SKILL_OPTIONS and the credentials in QUALIFICATION_OPTIONS — a hobby teacher
  // should never have to claim a chef qualification to appear. 'Cooking / Baking' is the
  // original umbrella and STAYS: live mentors already store it, and mentorHashtags /
  // mentorFilterState bucket by these exact strings, so removing it would de-bucket them.
  'Cooking / Baking', 'Cooking', 'Indian Cuisine', 'Continental Cuisine',
  'Baking & Confectionery', 'Cake Decorating', 'Home Chef / Home Cooking',
  'Baking',
  'Creative Writing', 'Poetry', "Rubik's Cube", 'Robotics for Kids', 'Astronomy',
  'Gaming / eSports',
];
